<template>
  <div class="info-success">
    <div class="top">
      <p>{{ payResult }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "JiaJiHuaCollegeInfoSuccess",
  data() {
    return {
      payResult: "提交成功",
    };
  },
  created() {
    // 直接显示成功，不需要查询接口
    // 如果有payNo参数，可以显示，但不查询状态
    // 可以显示订单号等信息，但不查询支付状态
    this.payResult = "提交成功";
  },
};
</script>
<style lang="less" scoped>
.info-success {
  position: relative;
  width: 100%;
  height: 100vh;
  background: url(../../../assets/pdmInfo/bg-success.png);
  background-position: top left;
  background-size: 100% auto;
  .top {
    text-align: center;
    padding-top: 150px;
    img {
      width: 128px;
      margin-top: 150px;
      transform: translate3d(10px, 0, 0);
    }
    p {
      font-weight: 600;
      font-size: 20px;
      color: #000;
    }
  }
  .button {
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: 30px;
    border-radius: 12px;
    background: rgba(21, 177, 129, 1);
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    padding: 13px 0;
    text-align: center;
  }
}
</style>




